//#region Util Imports

import * as moment from 'moment'
import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import ArrayStore from 'devextreme/data/array_store'
import DataSource from 'devextreme/data/data_source'

//#endregion

//#region Asset Imports

import { IMRBaseControlController } from '../base'
import { IIMRGridMasterDetails, IMRGridMasterDetailsOptions } from './grid-master-details.interfaces'
import { GridOptions } from '../grid'

//#endregion

export class GridMasterDetailsController
    extends
    IMRBaseControlController<IIMRGridMasterDetails, IMRGridMasterDetailsOptions>
    implements
    ng.IComponentController,
    IIMRGridMasterDetails {

    public gridOptions: GridOptions

    constructor(
    ) {
        super()
    }

    //#region Consts

    //#endregion

    //#region Component

    protected initialize(options: IMRGridMasterDetailsOptions): void {
        this.gridOptions = this.options.gridOptions
    }

    //#endregion

    //#region IIMRMasterDetails implementation


    //#endregion

}